import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Notification } from '@unified-checkout/design-system';
import { CreditCard } from '@unified-checkout/design-system/icons/index';
import { DeviceContext } from '../../../context/device';
import { INNER_ROUTES } from '../../../constants';

type PaymentAnnouncementProps = {
  onClose: () => void;
};
export const PaymentAnnouncement = ({ onClose }: PaymentAnnouncementProps) => {
  const navigate = useNavigate();

  const { isMobile } = useContext(DeviceContext);

  return (
    <Notification
      hasCloseIcon
      isMobile={isMobile}
      icon={CreditCard}
      title="No payment method added"
      hintText="Add your first payment method"
      show
      btnsProps={[
        {
          text: 'Not now',
          size: 'md',
          variant: 'link',
          color: 'secondary',
          onClickHandler: onClose,
        },
        {
          text: '+Add Debit/Credit card',
          color: 'primary',
          variant: 'link',
          onClickHandler: () => {
            navigate(INNER_ROUTES.PAYMENT_METHODS);
            onClose();
          },
        },
      ]}
    />
  );
};
